import { ACCOUNT_ROUTE_NAME } from "@/libs/route-name";

export const accountProfileRoute = () => {
  return {
    name: ACCOUNT_ROUTE_NAME.ACCOUNT_PROFILE,
    path: "account/profile",
    component: () => import("@/pages/profile/index.vue"),
    meta: {
      requireAuth: true
    }
  };
};

export const accountEditProfileRoute = () => {
  return {
    name: ACCOUNT_ROUTE_NAME.ACCOUNT_EDIT_PROFILE,
    path: "account/edit-profile",
    component: () => import("@/pages/profile/edit-profile.vue"),
    meta: {
      requireAuth: true
    }
  };
};

export const accountUpdatePasswordRoute = () => {
  return {
    name: ACCOUNT_ROUTE_NAME.ACCOUNT_UPDATE_PASSWORD,
    path: "account/update-password",
    component: () => import("@/pages/profile/update-password.vue"),
    meta: {
      requireAuth: true
    }
  };
};
